import * as React from 'react';

import { t } from 'utils/language';
import { abbrNum } from 'utils/helper/common';

type Props = {
  totalAudience: number
};

const StatisticsAudienceTotal = ({
  totalAudience
}: Props) => {
  const totalLabel = t('statistics.audience.overlap.total');

  const audienceDisplayValue = abbrNum(totalAudience);
  return (
    <div
      className="statistics-audience-total"
      title={`${totalLabel}: ${audienceDisplayValue}`}
    >
      <div className="statistics-audience-total__value">
        {audienceDisplayValue}
      </div>
      <div className="statistics-audience-total__label">
        {totalLabel}
      </div>
    </div>
  );
};

export default StatisticsAudienceTotal;
